<template>
  <section class="product-catalogs">
    <b-table
      :data="catalogs"
      :checked-rows.sync="checkedRows"
      :hoverable="true"
      :narrowed="true"
      :row-class="row => !row.status && 'has-text-grey-light'"
      :default-sort-direction="defaultSortOrder"
      :default-sort="[sortField, sortOrder]"
      :mobile-cards="false"
      checkable
      @check="onChecked"
    >
      <b-table-column
        field="status"
        :label="$t('attributes.activation_status')"
        width="95"
        style="vertical-align: middle"
        :visible="false"
        v-slot="props"
      >
        <b-icon :icon="props.row.status ? 'check' : 'close'"></b-icon>
      </b-table-column>

      <b-table-column
        field="sort"
        :label="$t('attributes.sort')"
        width="95"
        style="vertical-align: middle"
        :visible="true"
        v-slot="props"
      >
        {{ props.row.sort }}
      </b-table-column>

      <b-table-column
        field="catalog_no"
        :label="$t('attributes.catalog_code')"
        width="125"
        style="vertical-align: middle"
        v-slot="props"
      >
        {{ props.row.catalog_no }}
      </b-table-column>

      <b-table-column
        field="name"
        :label="$t('attributes.name')"
        v-slot="props"
      >
        {{ props.row.name }}
      </b-table-column>

      <b-table-column
        :label="$t('attributes.function')"
        width="120"
        centered
        v-slot="props"
      >
        <div class="buttons is-centered">
          <b-button
            type="is-info"
            size="is-small"
            @click.prevent.stop="onUpdateSort(props.row)"
          >
            {{ $t('attributes.product') + $t('attributes.sort') }}
          </b-button>
        </div>
      </b-table-column>

      <template #empty>
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>
              <b-icon icon="emoticon-sad" size="is-large" />
            </p>
            <p>{{ $t('attributes.empty') }}</p>
          </div>
        </section>
      </template>
    </b-table>

    <b-modal
      :active.sync="isProductListModelActive"
      :can-cancel="false"
      full-screen
      has-modal-card
    >
      <products-from
        :area-code="product.area_code"
        :catalog-no="selectedCatalogNumber"
      />
    </b-modal>

    <b-loading :active.sync="sending" is-full-page></b-loading>
  </section>
</template>

<script>
import { PRODUCTS_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'
import ProductsFrom from '@/components/catalogs/CatalogProductsFrom'

export default {
  name: 'ProductCatalogsForm',
  components: { ProductsFrom },

  props: {
    product: {
      required: true,
      type: Object
    },
    catalogs: {
      required: true,
      type: Array
    }
  },
  data() {
    return {
      sending: false,

      checkedRows: [],
      sortField: 'sort',
      sortOrder: 'asc',
      defaultSortOrder: 'asc',

      selectedCatalogNumber: null,
      isProductListModelActive: false
    }
  },
  watch: {
    product(product) {
      this.updateCheckedRows(product, this.catalogs)
    },
    catalogs(value) {
      this.updateCheckedRows(this.product, value)
    }
  },
  mounted() {
    this.updateCheckedRows(this.product, this.catalogs)
  },
  methods: {
    updateCheckedRows(product, catalogs) {
      if (!product || !catalogs) {
        return { checkedRows: [] }
      }

      this.checkedRows = catalogs.filter(catalog => {
        return product.catalog_list.includes(catalog.catalog_no)
      })
    },
    async onChecked(checkedList) {
      if (checkedList.length === 0) {
        return notifyService.error('分類至少選擇一個！')
      }

      await this.send(checkedList)
    },
    onUpdateSort(catalog) {
      this.selectedCatalogNumber = catalog.catalog_no
      this.isProductListModelActive = true
    },
    async onSend() {
      if (this.checkedRows.length === 0) {
        return notifyService.error('分類至少選擇一個！')
      }

      await this.send(this.checkedRows)
    },
    async send(checkedList) {
      const api = `${PRODUCTS_API}/${this.product.code}/catalogs`
      const data = {
        catalog_list: checkedList.map(c => c.catalog_no)
      }

      this.sending = true
      try {
        const res = await this.axios.put(api, data)

        this.$emit('updated', res.data.data)
        notifyService.success(this.$t('attributes.update_succeed'))
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.sending = false
      }
    }
  }
}
</script>
